import { createContext } from "react";

import type { FeatureFlagMap } from "../types";
import { defaultFeatureFlagProperties } from "./defaultFeatureFlagDefinitions";

/**
 * This is the official mock used in websdk-stub.js and as the basis for context
 */
export const defaultFeatureFlagDefinitions = Object.fromEntries(
  Object.entries(defaultFeatureFlagProperties).map(([flagId, properties]) => [
    flagId,
    {
      enabled: false,
      properties,
    },
  ])
) as FeatureFlagMap;

export const FeatureFlagListContext = createContext<FeatureFlagMap>(defaultFeatureFlagDefinitions);
